import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import CriminalHero from "./components/CriminalHero";
import CriminalAreas from "./components/CriminalAreas";
import CriminalWhy from "./components/CriminalWhy";

export default function Criminal() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <CriminalHero />
        <CriminalAreas />
        <CriminalWhy />
      </main>
      <Footer />
    </>
  );
}